module.exports = __webpack_public_path__ + "img/helper.afae15e0.svg";